module.exports = __webpack_public_path__ + "static/media/logoPositive.5273bff2.svg";